module.exports = __webpack_public_path__ + "static/media/img-01.92babc72.jpg";